export enum FirebasePermission {
  granted = 0,
  denied = 1,
  ask = 2
}
